var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 101,
    viewBox: "0 0 75 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#1FAF8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5001 24.1667H28.8334C27.861 24.1667 26.9283 24.553 26.2407 25.2406C25.5531 25.9283 25.1667 26.8609 25.1667 27.8334V49.8334C25.1667 50.8058 25.5531 51.7384 26.2407 52.4261C26.9283 53.1137 27.861 53.5 28.8334 53.5H47.1667C48.1392 53.5 49.0718 53.1137 49.7595 52.4261C50.4471 51.7384 50.8334 50.8058 50.8334 49.8334V27.8334C50.8334 26.8609 50.4471 25.9283 49.7595 25.2406C49.0718 24.553 48.1392 24.1667 47.1667 24.1667H43.5001",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8333 20.5H36.1667C34.1416 20.5 32.5 22.1416 32.5 24.1667C32.5 26.1917 34.1416 27.8333 36.1667 27.8333H39.8333C41.8584 27.8333 43.5 26.1917 43.5 24.1667C43.5 22.1416 41.8584 20.5 39.8333 20.5Z",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 37H32.5183",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8333 37H43.4999",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 44.3333H32.5183",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8333 44.3333H43.4999",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 79.5,
    r: 20.5,
    fill: "#121738",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 73L32 87",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73L46 87",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptOut);
export default __webpack_public_path__ + "static/media/opt-out.4596cef9a4f0b749cd30fd8ad3636191.svg";
export { ForwardRef as ReactComponent };